import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/logo.svg";
// api
import { forgotPassword } from "../../api/users";

// lib
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from "../../lib/isEmpty";

const initialFormValue = {
  email: "",
};

const ForgotPassForm = () => {
  //hooks
  const { t, i18n } = useTranslation();

  // state
  const [formValue, setFormValue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});
  const { email } = formValue;

  //function
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, ...{ [name]: value } });
    if (!isEmpty(errors)) {
      setErrors({});
    }
  };

  const handleSubmit = async (e) => {
    try {
      const { status, message, errors } = await forgotPassword({ email });
      if (status == "success") {
        setFormValue(initialFormValue);
        toastAlert("success", t(message), "signup", "TOP_CENTER");
      } else {
        if (errors) {
          setErrors(errors);
          return false;
        }
        toastAlert("error", t(message), "signup", "TOP_CENTER");
      }
    } catch (err) {}
  };

  return (
    <>
      <div className="login_page_wrapper">
        <div className="login_split_container">
          {/* Left Side - Image (50%) */}
          <div className="login_image_half d-none d-lg-block">
            <img
              src={require("../../assets/images/home/auth_bg.png")}
              alt="Professional Meeting"
              className="login_image_full"
            />
          </div>

          {/* Right Side - Form (50%) */}
          <div className="login_form_half">
            <div className="login_form_wrapper">
              {/* Logo Section */}
              <div className="login_logo_section">
                <Link className="" to="/">
                  <img
                    src={logo}
                    className="img-fluid brand_logo"
                    alt="Light logo"
                  />
                </Link>
              </div>

              {/* Forgot Password Title */}
              <h2 className="login_form_title mb-1">{t("FORGOT_PASSWORD")}</h2>

              {/* Description */}
              <p className="form_checkbox_label mb-5">{t("FORGOT_PASSWORD_CONTENT")}</p>

              {/* Form */}
              <form className="login_form_fields">
                {/* Email Field */}
                <div className="form_field_group">
                  <label htmlFor="email" className="form_field_label">
                    {t("EMAIL")}
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form_field_input"
                    placeholder={t("EMAIL_PLACEHOLDER")}
                    name="email"
                    onChange={handleChange}
                    value={email}
                  />
                  {errors?.email && (
                    <span className="form_field_error">{t(errors?.email)}</span>
                  )}
                </div>

                {/* Submit Button */}
                <button
                  type="button"
                  className="primary_btn mt-4"
                  onClick={handleSubmit}
                >
                  {t("SUBMIT")}
                </button>
              </form>

              {/* Sign In Link */}
              <p className="form_signup_text">
                <Link to="/login" className="form_signup_link">
                  {t("SIGN_IN")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassForm;
